import * as React from 'react';

import { useQuery } from '@apollo/client';

import DegreesMartechExperiments from 'bundles/epic/clients/DegreesMartech';
import EoiForm from 'bundles/expression-of-interest/components/eoi-v1/EoiForm';
import type {
  GetDegreeDataBySlugQuery,
  GetDegreeDataBySlugQueryVariables,
} from 'bundles/expression-of-interest/queries/__generated__/getDegreeDataBySlug';
import getDegreeDataBySlug from 'bundles/expression-of-interest/queries/getDegreeDataBySlug.graphql';
import { appendUtmParametersToApplicationLink } from 'bundles/expression-of-interest/utils/util';
import { ProductTypes } from 'bundles/university-program-qualification/utils/constants';
import type { Maybe } from 'bundles/xddp/__generated__/baseContentfulTypes';

const { DEGREE } = ProductTypes;

type Props = {
  slug: string;
  partnerName?: Maybe<string>;
  applicationUrl?: string;
  eoiConfirmationText?: string;
};

const EoiContainer = ({ slug, partnerName, applicationUrl, eoiConfirmationText }: Props): JSX.Element | null => {
  const { data } = useQuery<GetDegreeDataBySlugQuery, GetDegreeDataBySlugQueryVariables>(getDegreeDataBySlug, {
    variables: { slug },
    context: {
      clientName: 'gatewayGql',
      errorPolicy: 'all',
    },
  });

  const onSubmitSuccess = () => {
    if (applicationUrl) {
      const urlWithUTMParameters = appendUtmParametersToApplicationLink(applicationUrl);
      window.open(urlWithUTMParameters, '_blank', 'noopener noreferrer');
    }
  };

  const shouldShowRequiredEoiUpenn = DegreesMartechExperiments.get('shouldShowRequiredEoiUpenn');

  if (!partnerName) {
    return null;
  }

  return (
    <div className="rc-EoiContainer">
      <EoiForm
        productId={data?.Degree?.queryBySlug?.id || ''}
        productType={DEGREE}
        slug={slug}
        partnerName={partnerName}
        eoiConfirmationText={eoiConfirmationText}
        {...(shouldShowRequiredEoiUpenn && { onSubmitSuccess })}
      />
    </div>
  );
};

export default EoiContainer;
